import {http} from './index';
import {GetPermissionListParams, GetPermissionActionHistoryParams, GetUserRoleByIdParams, SavePermissionDetailParams,Synchronization, SetAnswerLimitParams} from '@types';

export const getActiveUserRole = () => http.get('/teaching-workbench/qa/user/current');

export const getUserRoleById = (params: GetUserRoleByIdParams) => http.get('/teaching-workbench/qa/user', params);

export const getPermissionList = (params: GetPermissionListParams) => http.get('/teaching-workbench/qa/user/page', params);

export const savePermissionDetail = (params: SavePermissionDetailParams) => http.post('/teaching-workbench/qa/user/save', params);
export const synchronizationApi = (params: Synchronization) => http.get('/teaching-workbench/qa-user-vigo-project/init', params);

export const setAnswerLimitApi = (params: SetAnswerLimitParams) => http.post('/teaching-workbench/qa/user/batch/save/upper', params);
export const setSingleAnswerLimitApi = (params: SetAnswerLimitParams) => http.post('/teaching-workbench/qa/user/single/save/upper', params);
//解绑用户公众号
export const unbindWxAppId = (params: {userId:string|number,vigoUserId:string|number,wxAppId:string}) => http.post('/teaching-workbench/qa/user/unbind/wx/app', params);
